import React from "react";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
const FloatingSpeedDial = () => {
  const phoneNumber = "+918920223385"; // Replace with your WhatsApp number
  const emailAddress = "admissionsexpert@globaleducationtalent.com"; // Replace with your email

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${phoneNumber}`, "_blank");
  };

  const handleMailClick = () => {
    window.open(`mailto:${emailAddress}`, "_blank");
  };

  return (
    <SpeedDial
      ariaLabel="Contact Options"
      sx={{
        position: "fixed",
        bottom: 20,
        right: 20,
        zIndex: 1000, // Ensure it's above other elements
      }}
      icon={<QuestionMarkIcon />}
    >
      <SpeedDialAction
        icon={<WhatsAppIcon color="success" />}
        tooltipTitle="WhatsApp"
        onClick={handleWhatsAppClick}
      />
      <SpeedDialAction
        icon={<EmailIcon color="primary" />}
        tooltipTitle="Email"
        onClick={handleMailClick}
      />
    </SpeedDial>
  );
};

export default FloatingSpeedDial;
